export const categoryPresets = ['Tarifs', 'Règlement intérieur', 'Horaires', 'Accessibilité', 'Informations pratiques'];
export const documentCategory = (d) => (d.category || '').trim();
export const categoryLabel = (c) => c || 'Non classés';
export function categoriesFor(docs = []) {
  return [...new Set([...categoryPresets, ...docs.map(documentCategory)].filter(Boolean))].sort((a, b) => a.localeCompare(b, 'fr'));
}
export function groupDocuments(docs = []) {
  const groups = new Map();
  for (const d of docs) {
    const c = documentCategory(d);
    if (!groups.has(c)) groups.set(c, []);
    groups.get(c).push(d);
  }
  return [...groups].map(([category, documents]) => ({ category, label: categoryLabel(category),
    documents: documents.toSorted((a, b) => a.title.localeCompare(b.title, 'fr')) }))
    .sort((a, b) => a.category === '' ? 1 : b.category === '' ? -1 : a.label.localeCompare(b.label, 'fr'));
}
export function accessState(documents, agentId) {
  const count = documents.filter((d) => (d.agent_ids || []).includes(agentId)).length;
  return { count, checked: documents.length > 0 && count === documents.length, mixed: count > 0 && count < documents.length };
}
export function matchesDocument(d, query) {
  const text = [d.title, d.source_url, categoryLabel(documentCategory(d))].join(' ').toLocaleLowerCase('fr');
  return text.includes(query.trim().toLocaleLowerCase('fr'));
}
